import { useWhitelabel, WhitelabelProvider } from '@ux/whitelabel';
import { useCalculateCurrency, CurrencyProvider } from '@ux/currency';
import { useInitialize, useLanguage, LanguageProvider } from '@ux/language';
import { useEffect } from 'react';
import { useWindow } from '@uds/hooks';
import { jsx, Fragment } from 'react/jsx-runtime';

function useCurrency(ready) {
  const calculate = useCalculateCurrency();

  // calculates and writes the currency cookie
  useEffect(() => {
    if (ready) {
      calculate();
    }
  }, [ready, calculate]);
}

const SENSITIVE_KEYS = ['token', 'tokenId', 'kvp', 'payerId'];

const useFilterSensitiveQueryParams = _ref => {
  let {
    sensitiveKeys
  } = _ref;
  const window = useWindow();
  const location = window.location;
  const params = new URLSearchParams(location.search);
  (sensitiveKeys != null ? sensitiveKeys : SENSITIVE_KEYS).forEach(key => {
    params.delete(key);
  });
  let query = params.toString();
  if (query !== '') {
    query = `?${query}`;
  }
  window.history.replaceState({}, '', `${location.pathname}${query}${location.hash}`);
};
var useFilterSensitiveQueryParams$1 = useFilterSensitiveQueryParams;

function useOrchestration(_ref) {
  let {
    sensitiveKeys = []
  } = _ref;
  // stores the apps for whitelabel and begins fetching the brand pilot config
  const [wlReady] = useWhitelabel();

  // stores the scopes for language and prefetches language/messages
  // writes the preferred language cookie
  const [langReady] = useInitialize();
  const ready = wlReady && langReady;

  // calculates and writes the currency cookie
  useCurrency(wlReady);

  // remove sensitive query params
  useFilterSensitiveQueryParams$1({
    sensitiveKeys
  });
  return ready;
}

const Orchestration = _ref => {
  let {
    children,
    loader = null,
    sensitiveKeys
  } = _ref;
  const isReady = useOrchestration({
    sensitiveKeys
  });
  if (!isReady) {
    return loader;
  }
  return /*#__PURE__*/jsx(Fragment, {
    children: children
  });
};
const OrchestrationProvider = _ref2 => {
  let {
    children,
    apps,
    scopes,
    loader,
    sensitiveKeys
  } = _ref2;
  return /*#__PURE__*/jsx(WhitelabelProvider, {
    apps: apps,
    useLanguage: useLanguage,
    children: /*#__PURE__*/jsx(LanguageProvider, {
      scopes: scopes,
      children: /*#__PURE__*/jsx(CurrencyProvider, {
        children: /*#__PURE__*/jsx(Orchestration, {
          loader: loader,
          sensitiveKeys: sensitiveKeys,
          children: children
        })
      })
    })
  });
};
var OrchestrationProvider$1 = OrchestrationProvider;

export { OrchestrationProvider$1 as OrchestrationProvider };
